import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';
import { redactPublishedAccess } from '@/_core/utils/publishedAccessRedaction';

if (bugSnagData.isEnabled) {
    const metaData = {
        workspace: {
            workspaceSubdomain: initAppData.isInWsContext ? initAppData.appUrls.currentSubdomain : '',
            workspaceUrl: initAppData.appUrls.appUrl,
            workspaceId: initAppData.isInWsContext ? initAppData.currentWs.workspaceId : 0,
            userRoles: initAppData.isInWsContext ? initAppData.currentWs.userRoles : '',
        },
        userAllData: {
            id: initAppData.currentUser.currentUserId,
            shortId: initAppData.currentUser.currentUserShortId,
            name: initAppData.currentUser.currentUserFullName,
            email: initAppData.currentUser.currentUserLoginName,
        },
        kind: { kind: 'client-side' },
    };

    Bugsnag.start({
        apiKey: bugSnagData.apiKey,
        plugins: [new BugsnagPluginVue()],

        releaseStage: bugSnagData.enviroment,
        user: {
            id: initAppData.currentUser.currentUserId,
            name: initAppData.currentUser.currentUserFullName,
            email: initAppData.currentUser.currentUserLoginName,
        },
        metadata: metaData,
        maxBreadcrumbs: 0,

        context: `[${metaData.workspace.workspaceSubdomain ? metaData.workspace.workspaceSubdomain : 'app'}] ${redactPublishedAccess(location.pathname)}`,

        onError: function (event) {
            event.context = redactPublishedAccess(event.context);
            if(event?.originalError?.message == '[Abort by force]'){
                return false;
            }
            // The Vue error handler adds the failing component's props (delivered attachment URLs, converted
            // descriptions, published access keys) as 'vue' metadata; pass them through the same redaction.
            // Cleared first, so a failing redaction never sends the unredacted props.
            const vueMetadata = event.getMetadata('vue');
            if (vueMetadata) {
                event.clearMetadata('vue');
                event.addMetadata('vue', redactPublishedAccess(vueMetadata));
            }
            return true;
        },
    });

    Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);
}
